import prepText, {
  prepTriangle,
  regexpTrademark,
  regexpTriangleGlobal,
} from '../../../lib/prepText.ts';

let pmiSymbolsHandlerDone = false;

const pmiSymbolsHandler = () => {
  const content = document?.querySelectorAll(`h1, h2, h3, h4, h5, h6`);

  content?.forEach(contentItem => {
    const contentItemArray = contentItem?.childNodes ? Array.from(contentItem?.childNodes) : [];

    contentItemArray
      .filter(
        child =>
          child?.nodeType === 3 &&
          (regexpTriangleGlobal.test(child?.nodeValue) || regexpTrademark.test(child?.nodeValue)),
      )
      .forEach(childItem => {
        const parentNode = childItem?.parentNode;
        const parentNodeTagName = parentNode?.tagName;

        // Check if the parent node has a slot (light DOM projected content)
        const assignedSlot = parentNode?.assignedSlot;

        // If it has a slot, work with the light DOM content (assignedSlot)
        if (assignedSlot) {
          const originalText = childItem.nodeValue;

          const updatedText = prepTriangle(prepText(originalText));

          // Create a temporary container to hold the replaced HTML structure
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = updatedText;

          // Replace the original text node with the new content in the light DOM
          childItem.replaceWith(...tempContainer.childNodes);
        } else if (parentNode && parentNodeTagName && !parentNodeTagName.includes('-')) {
          // For normal DOM elements, proceed with the usual replacement
          const originalText = childItem.nodeValue;

          const updatedText = prepTriangle(prepText(originalText));

          // Create a temporary container to hold the replaced HTML structure
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = updatedText;

          // Replace the original text node with the new content
          childItem.replaceWith(...tempContainer.childNodes);
        }
      });
  });
};

if (document?.readyState === 'loading') {
  // DOM is still loading, you can add a 'DOMContentLoaded' event listener here
  document?.addEventListener('DOMContentLoaded', () => {
    if (!pmiSymbolsHandlerDone) {
      setTimeout(pmiSymbolsHandler, 10);
      pmiSymbolsHandlerDone = true;
    }
  });
} else {
  // 'DOMContentLoaded' has already passed, you can run your code directly
  if (!pmiSymbolsHandlerDone) {
    setTimeout(pmiSymbolsHandler, 10);
    pmiSymbolsHandlerDone = true;
  }
}
